import { store } from '@risingstack/react-easy-state';
import { ConfirmAction } from 'types';

interface ConfirmDialogState {
  pending: (ConfirmAction & { onConfirm: () => void; onCancel: () => void }) | undefined;
}

const localStore = store<ConfirmDialogState>({ pending: undefined });

export const confirmDialogStore: Readonly<ConfirmDialogState> = localStore;

export const askConfirm = (props: ConfirmAction): Promise<boolean> => {
  if (localStore.pending) {
    localStore.pending.onCancel();
  }

  return new Promise<boolean>((resolve) => {
    localStore.pending = {
      ...props,
      onConfirm: () => {
        localStore.pending = undefined;
        resolve(true);
      },
      onCancel: () => {
        localStore.pending = undefined;
        resolve(false);
      },
    };
  });
};

export const dismissConfirmDialog = () => {
  if (localStore.pending) {
    localStore.pending.onCancel();
  }
};
